import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card schedule" }
const _hoisted_2 = { class: "schedule-header" }
const _hoisted_3 = ["href"]
const _hoisted_4 = {
  key: 1,
  class: "content"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrimeVueSkeleton = _resolveComponent("PrimeVueSkeleton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "card-header" }, [
      _createElementVNode("div", { class: "card-title" }, [
        _createElementVNode("h6", null, "Endpoints with an excessive number of subids 🚨"),
        _createElementVNode("p", { class: "subtitle" }, "Today")
      ])
    ], -1)),
    (_ctx.statisticsLoading)
      ? (_openBlock(), _createBlock(_component_PrimeVueSkeleton, {
          key: 0,
          height: "60px"
        }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_ctx.statistics.length)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("p", null, _toDisplayString(_ctx.statistics.length) + " endpoints", 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statistics, (data, index) => {
                  return (_openBlock(), _createElementBlock("ul", { key: index }, [
                    _createElementVNode("li", null, [
                      _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("a", {
                          class: "mt-1",
                          href: `/endpoints/${data.endpoint.id}`,
                          target: "_blank"
                        }, _toDisplayString(data.endpoint.compiled_name), 9, _hoisted_3)
                      ]),
                      _createElementVNode("span", null, _toDisplayString(data.new_subids) + " subids", 1)
                    ])
                  ]))
                }), 128))
              ], 64))
            : (_openBlock(), _createElementBlock("div", _hoisted_4, "No one exceeds the limits 👌"))
        ], 64))
  ]))
}